/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class FxRateGrid extends SiteEntityGrid<FxRateRow, any> {
        protected getColumnsKey() { return 'Data.FxRate'; }
        protected getDialogType() { return FxRateDialog; }
        protected getIdProperty() { return FxRateRow.idProperty; }
        protected getLocalTextPrefix() { return FxRateRow.localTextPrefix; }
        protected getService() { return FxRateService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}